import React from 'react'
import PropTypes from 'prop-types'
import toggleOpen from "../../decorators/toggleOpen"
import cn from "classnames"
import refreshIcon from '../../_static/images/refresh.svg'


let Rotate = (props, context) => {
    let {isOpen : isRotated, toggleOpen : rotate, onClick, alt = 'refresh'} = props
    const {formatMessage} = context

    return (
        <div className={cn("pointer mx-1 rotate", {rotated : isRotated})} onClick={() => {
            rotate()
            typeof onClick === 'function' && onClick()
        }}><img width={35} height={35} src={refreshIcon} alt={formatMessage(alt)}/></div>
    )
}

Rotate.contextTypes = {formatMessage: PropTypes.any}


export default toggleOpen(Rotate)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Rotate.js